import { createFileRoute } from '@tanstack/react-router';
import { TenantContext } from '@interxfi/api-client/realm-context';
import type { RouteGuardOptions } from '../../../util/routing/guard';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required')({
  staticData: {
    guard: { access: { allowedTenantTypes: [TenantContext.Clearing] } },
  } as const satisfies RouteGuardOptions,
  shouldReload: true,
  preload: false,
});
